export function showStatusModal() {
  return {
    type: 'SHOW_STATUS_MODAL'
  };
}

export function hideStatusModal() {
  return {
    type: 'HIDE_STATUS_MODAL'
  };
}

export function fadeOutStatusModal() {
  return {
    type: 'FADE_OUT_STATUS_MODAL'
  };
}

export function hideStatusModalWithAnimation() {
  return function (dispatch) {
    dispatch(fadeOutStatusModal());
    setTimeout(() => dispatch(hideStatusModal()), 800);
  };
}

export function goneBack() {
  return {
    type: 'GONE_BACK',
  };
}

export function goBack() {
  return {
    type: 'GO_BACK',
  };
}
